import { NON_PURCHASABLE_ECOMMERCE_PLANS } from '../constants/subscription-type';
import SubscriptionTerm from '../constants/subscription-term';
import prioritizer from '../prioritizer';
import type {
  SubscriptionType,
  SubscriptionTerm as SubscriptionTermType,
} from '../types/subscription';

const isPlanAvailable = ({
  plan,
  currentPlan,
  minRequiredPlan,
  term,
  currentTerm,
}: {
  plan: SubscriptionType;
  currentPlan?: SubscriptionType;
  minRequiredPlan?: SubscriptionType;
  term?: SubscriptionTermType;
  currentTerm?: SubscriptionTermType;
}): boolean => {
  let isAvailableForCurrentPlan = true;

  if (currentPlan) {
    const canUpgradeToCurrentPlan =
      currentTerm === SubscriptionTerm.MONTHLY && term === SubscriptionTerm.ANNUAL;

    isAvailableForCurrentPlan = canUpgradeToCurrentPlan
      ? prioritizer.getPriority(plan) >= prioritizer.getPriority(currentPlan)
      : prioritizer.getPriority(plan) > prioritizer.getPriority(currentPlan);
  }

  const isAvailableForMinRequiredPlan = minRequiredPlan
    ? prioritizer.getPriority(plan) >= prioritizer.getPriority(minRequiredPlan)
    : true;
  const isDeprecatedPlan = NON_PURCHASABLE_ECOMMERCE_PLANS.some(
    (nonPurchasablePlan) => plan === nonPurchasablePlan
  );

  return !isDeprecatedPlan && isAvailableForCurrentPlan && isAvailableForMinRequiredPlan;
};

export default isPlanAvailable;
